module.exports = __webpack_public_path__ + "static/media/accessorials.992d6d83.svg";